// Tiny shared UI-state bus for cross-component coordination without prop drilling.
// Flags: menu (mobile nav open), overlay (planner/lightbox open), stickyCta (mobile
// sticky reserve bar visible). Used by the sticky CTA and the Passport List popup
// to yield to each other and to page overlays.
const state = { menu: false, overlay: false, stickyCta: false };
const subs = new Set();

export function setUiFlag(key, value) {
  if (state[key] === value) return;
  state[key] = value;
  subs.forEach((fn) => fn({ ...state }));
}

export function getUiState() {
  return { ...state };
}

export function onUiChange(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
